module.exports = __webpack_public_path__ + "img/icon-cx-mew.d124725e.svg";